import axios from "axios";

import Config from "src/config";

const v1_actionWboSincronizarTemplates = (clienteId, canalId, data) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/${clienteId}/canais/wbo/templates/sincronizar/${canalId}`,
        data
    });
};

export default v1_actionWboSincronizarTemplates;
